const LeadID = 81;

const Environment = () => {
  var isLocalhost = Boolean(
    window.location.hostname === "localhost" ||
      window.location.hostname === "[::1]" ||
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
  );

  var isQA = Boolean(
    window.location.href.match("source-qa") || window.location.href.match("qa.")
  );

  var isSource = Boolean(window.location.href.match("source-"));

  return {
    isLocalhost: isLocalhost,
    isQA: isQA,
    isTest: isQA || isLocalhost,
    isSource: isSource,
  };
};

const switchURLapi = (LocalHost, QADomain, PRODDomain) => {
  if (Environment().isLocalhost) {
    return LocalHost;
  } else {
    if (Environment().isQA) {
      return QADomain;
    } else {
      if (Environment().isQA) {
        return QADomain;
      } else {
        return PRODDomain;
      }
    }
  }
};

const apiURL = switchURLapi(
  "https://localhost:44381/api/",
  "https://qa-a.ynet.co.il/mShort/generics/Leads/api/api/",
  "https://z.ynet.co.il/mShort/generics/Leads/api/api/"
);

export const sendLead = async (leadData) => {
  try {
    /*
            fullName: "",
    phone: "",
    email: "",
    bussinessName: "",
    activity: "",
    bussinessId: "",
    bussinessLocation: "",
    poalimClient: true,
    description: "",
    digitalChoice: "",
    tosAgree: false,
    privacyAgree: false,
        */
    var form = new FormData();
    const jsonData = {
      LeadID: LeadID,
      FullName: leadData.fullName,
      Email: leadData.email,
      ExtraField1: leadData.bussinessName,
      ExtraField2: leadData.activity,
      IdentityNumber: leadData.bussinessId,
      City: leadData.bussinessLocation,
      Street: leadData.poalimClient ? "לקוח פועלים" : "לא לקוח פועלים",
      PlainText: leadData.description,
      PlainText2: leadData.digitalChoice,
      PhoneNumber: leadData.phone,
      Gender: leadData.privacyAgree ? 1 : 0
    };

    for (var key in jsonData) {
      form.append(key, jsonData[key]);
    }
    var res;
    let isExists = await fetch(`${apiURL}isExists`, {
      method: "POST",
      body: form,
    }).then((data) => data.json()).then(data => res = data);
    // console.log(res)
    if (res) {
      
      return false;
    }

    fetch(`${apiURL}Save`, {
      method: "POST",
      body: form,
    })
      .then((data) => data.json())
    //   .then((data) => console.log(data));
    
    return true;
  } catch {

  }
};
